import React from 'react';
import { Icon, Tooltip } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import styles from './styles';

export const getRowActionsWidth = (actions = []) => {
  const hasMenu = actions?.some((action) => action?.menu);
  const visibleActions = actions?.filter((action) => !action?.menu);

  return Math.max(
    100,
    44 * (visibleActions?.length || 1) + (hasMenu ? 44 : 0)
  );
};

const RowActions = ({ actions = [], params }) =>
  [...actions]
    ?.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
    ?.map(({ icon, name, action, color, menu, show = () => true }) => {
      const visible = typeof show === 'function' ? show(params) : show;

      if (!visible) {
        return null;
      }

      return (
        <GridActionsCellItem
          key={name}
          icon={
            menu ? (
              <Icon sx={{ color }}>{icon}</Icon>
            ) : (
              <Tooltip title={name}>
                <Icon sx={{ color }}>{icon}</Icon>
              </Tooltip>
            )
          }
          label={name}
          showInMenu={menu}
          onClick={() => action?.(params)}
          disabled={!action}
          sx={styles.actionCell}
        />
      );
    })
    ?.filter(Boolean);

export default RowActions;
